import React from "react";

interface props {
  children: React.ReactNode;
}

export default function HowToLine({ children }: props) {
  return <p className="pb-2 max-w-[65ch] mx-auto">{children}</p>;
}
